import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=188560d6&"
import script from "./Jumbotron.vue?vue&type=script&lang=ts&"
export * from "./Jumbotron.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports